import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "@/shared/ui";
import DeviceTabContentWrapper from "@/shared/widgets/DeviceTabContentWrapper";
import useVehicles from "@/domains/estate/hooks/useVehicles.ts";
import EstateVehiclesListContainer from "@/domains/estate/containers/tablet/tabs/vehicles/EstateVehiclesListContainer";
import EstateVehiclesTabsContainer from "@/domains/estate/containers/tablet/tabs/vehicles/EstateVehiclesTabsContainer";
import EstateVehicleChargingStation from "@/domains/estate/components/vehicles/EstateVehicleChargingStation";
import EstateVehicleInfo from "@/domains/estate/components/vehicles/EstateVehicleInfo";

export default function EstateVehiclesContainer({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation("estate");
  const {
    vehicleDetail,
    loadVehicleDetail,
    setVehicleDetail,
    resetting,
    parkingReset,
    detaching,
    characterDetach,
  } = useVehicles();
  const changeIsChargingModalSelector = useCallback(() => {}, []);

  const header = vehicleDetail ? (
    <div className="flex items-center gap-2.5">
      <Button
        variant="soft"
        color="gray"
        className="p-0 w-[2rem] h-[2rem] shrink-0 font-arial text-[0.7rem]"
        onClick={() => {
          setVehicleDetail(null);
        }}
      >
        &#9668;
      </Button>
      <div className="text-18 text-white font-bold">{t("estate.vehicles.showTitle")}</div>
    </div>
  ) : (
    t("estate.vehicles.title")
  );

  let footer = null;

  if (vehicleDetail) {
    footer = (
      <Button
        variant="soft"
        color="gray"
        onClick={() => parkingReset(vehicleDetail.vehicleId)}
        disabled={resetting}
        loading={resetting}
        className="h-11"
      >
        {t("estate.vehicles.parkingReset")}
      </Button>
    );
  } else {
    footer = <EstateVehicleChargingStation openChargeModal={changeIsChargingModalSelector} />;
  }

  return (
    <DeviceTabContentWrapper
      header={header}
      footer={footer}
      withGradient={!vehicleDetail}
      onClose={onClose}
      className="p-0"
    >
      {vehicleDetail ? (
        <EstateVehicleInfo
          vehicle={vehicleDetail}
          onCharacterDetach={characterDetach}
          isDetaching={detaching}
        />
      ) : (
        <div className="h-full flex flex-col gap-2.5">
          <EstateVehiclesTabsContainer />
          <div className={clsx("relative grow")}>
            <div className="absolute top-0 bottom-0 left-0 w-[calc(100%+1.0625rem)] pr-[0.8125rem] overflow-x-clip overflow-y-auto [scrollbar-gutter:stable]">
              <EstateVehiclesListContainer
                onSelectVehicleId={(vehicleId) => {
                  loadVehicleDetail(vehicleId);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </DeviceTabContentWrapper>
  );
}
